import * as React from 'react'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import LuxPlusLogo from 'luxPlus/components/Logos/LuxPlusLogo'
import { useAppSelector } from 'hooks/reduxHooks'
import { getIsLuxPlusEnabled } from 'luxPlus/selectors/featureToggle'
import Label from 'LuxKit/Label/Label'
import Clickable from 'components/Common/Clickable'
import InlineIcon from 'components/utils/InlineIcon'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'

const LOGO_HEIGHT = 10

const MemberExclusiveLabel = styled(Label)`
  &&& {
    background-color: var(--palette-product-lux-plus-background);
    border-color: var(--palette-product-lux-plus-foreground);
    color: var(--palette-product-lux-plus-contrast);
    /* The badge reads as a single unit; the base label allows wrapping by default,
     * which splits the copy onto a second line when it sits in a horizontal row. */
    white-space: nowrap;
  }
`

interface Props {

  showInfoIcon?: boolean
  onInfoClick?: (event: React.MouseEvent<HTMLElement>) => void
}

function MaldivesReturnForFreeMemberLabel({ showInfoIcon = false, onInfoClick }: Props) {
  const isLuxPlusEnabled = useAppSelector(getIsLuxPlusEnabled)

  if (!isLuxPlusEnabled) {
    return null
  }

  return (
    <MemberExclusiveLabel
      kind="primary"
      variant="highlight"
      format="propercase"
      data-testid="maldives-return-for-free-member-label"
    >
      <FormattedMessage
        id="f4EH6C0rhRG620Rqcm1W"
        defaultMessage="{logo} Member Exclusive"
        description="Badge on the Maldives return for free campaign surfaces marking the free return flight as a benefit available only to LuxPlus plus members"
        values={{ logo: <LuxPlusLogo colour="inherit" height={LOGO_HEIGHT} inline /> }}
      />
      {showInfoIcon && (onInfoClick
        ? <Clickable onClick={onInfoClick}><InlineIcon Icon={LineInfoCircleIcon} colour="inherit" /></Clickable>
        : <InlineIcon Icon={LineInfoCircleIcon} colour="inherit" />)}
    </MemberExclusiveLabel>
  )
}

export default MaldivesReturnForFreeMemberLabel
